/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxSearchIndexListRouteController", (function iife() {
	"use strict";

	function SearchIndexListRouteController(
		dxSearchIndexService
	) {
		var self = this;

		self.indexNames = [];
		self.errorMessage = null;

		dxSearchIndexService.listIndices().then(listIndicesSuccess, listIndicesRejected);

		function listIndicesSuccess(response) {
			self.indexNames = response.data;
		}

		function listIndicesRejected(response) {
			self.errorMessage = response.data.msgs[0];
		}
	}

	return SearchIndexListRouteController;
}()));
